// Determine if we're in production environment
// Check multiple sources to determine production status
const checkProduction = () => {
  // Primary check: NODE_ENV (set at build time)
  if (process.env.NODE_ENV === 'production') {
    return true;
  }

  // Secondary check: REACT_APP_ENV environment variable
  if (process.env.REACT_APP_ENV === 'production') {
    return true;
  }

  // Tertiary check: Hostname (runtime check, only if window is available)
  // But exclude local network addresses (LAN/private IP ranges)
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;

    // Check if it's a local/development address
    const isLocalAddress =
      hostname === 'localhost' ||
      hostname.includes('127.0.0.1') ||
      hostname.includes('0.0.0.0') ||
      // Private IP ranges (LAN addresses)
      hostname.match(/^192\.168\./) ||
      hostname.match(/^10\./) ||
      hostname.match(/^172\.(1[6-9]|2[0-9]|3[0-1])\./) ||
      // Link-local addresses
      hostname.match(/^169\.254\./);

    // Only return true (production) if it's NOT a local address
    if (!isLocalAddress) {
      return true;
    }
  }

  return false;
};

const isProduction = checkProduction();

// Production API URLs
const PRODUCTION_API_URL = 'https://admin-api.explosionsocial.com/api';
const PRODUCTION_SERVER_URL = 'https://admin-api.explosionsocial.com';

// Development API URLs (defaults). Derived from the page's own hostname at
// runtime rather than hardcoded to 'localhost' — "localhost" means something
// different on every device, so a phone loading this app from the Mac's LAN
// IP would otherwise try (and fail) to reach itself instead of the Mac. The
// API server is assumed to run on the same host as this app, on port 8080.
const runtimeHost = typeof window !== 'undefined' && window.location ? window.location.hostname : 'localhost';
const DEVELOPMENT_API_URL = `http://${runtimeHost}:8080/api`;
const DEVELOPMENT_SERVER_URL = `http://${runtimeHost}:8080`;

// Determine URLs based on environment or explicit env vars
const apiUrl = process.env.REACT_APP_API_URL ||
  (isProduction ? PRODUCTION_API_URL : DEVELOPMENT_API_URL);

const serverUrl = process.env.REACT_APP_SERVER_URL ||
  (isProduction ? PRODUCTION_SERVER_URL : DEVELOPMENT_SERVER_URL);

// Logo overrides — default to ESX's own assets so ESX's build is
// unaffected; a tenant profile (e.g. .env.production.toolvids) sets these
// to point at its own logo file in public/ instead.
export const LOGO_ICON_PATH = process.env.REACT_APP_LOGO_ICON_PATH || '/logo_icon.png';
export const JOIN_LOGO_PATH = process.env.REACT_APP_JOIN_LOGO_PATH || '/join_logo_big.png';

// Brand name + full-size logo used across the signup/account flow (SignUp,
// VerifyEmail, TermsAgreement, ThankYouPage, UserProfile, UserSettingsPage,
// SampleVideosPage, and PublicBlogPage's "About" sheet logo) — all previously
// hardcoded to ESX's own "BoostHealthDaily" / log_big.png with no override.
// About sheet body copy: REACT_APP_ABOUT_* vars below (defaults = BoostHealthDaily).
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'BoostHealthDaily';
export const BIG_LOGO_PATH = process.env.REACT_APP_BIG_LOGO_PATH || '/log_big.png';

// Public blog "About" sheet (PublicBlogPage) — tenant-specific via build profile.
export const ABOUT_DESCRIPTION = process.env.REACT_APP_ABOUT_DESCRIPTION || '';
export const ABOUT_BRANDS_INTRO =
  process.env.REACT_APP_ABOUT_BRANDS_INTRO ||
  'If you are a health brand or service interested in setting up your offer for our influencers to promote, contact:';
export const ABOUT_CONTACT_EMAIL =
  process.env.REACT_APP_ABOUT_CONTACT_EMAIL || 'fraser@explosionsocial.com';
export const ABOUT_INFLUENCERS_CTA =
  process.env.REACT_APP_ABOUT_INFLUENCERS_CTA ||
  "For Influencers interested in making money on your uploaded Health videos hit the button and let's get started!";
export const HAS_CUSTOM_ABOUT_DESCRIPTION = Boolean(process.env.REACT_APP_ABOUT_DESCRIPTION);

export const config = {
  // API URL for API calls (with /api suffix)
  API_URL: apiUrl,

  // Server URL for redirects (without /api suffix)
  SERVER_URL: serverUrl,

  APP_PORT: process.env.PORT || 3001,

  // Environment info (for debugging)
  IS_PRODUCTION: isProduction,
  ENVIRONMENT: isProduction ? 'production' : 'development'
};

// Log configuration for debugging (only in development)
if (process.env.NODE_ENV === 'development' || !isProduction) {
  console.log('🔧 Configuration:', {
    environment: config.ENVIRONMENT,
    isProduction: config.IS_PRODUCTION,
    apiUrl: config.API_URL,
    serverUrl: config.SERVER_URL,
    nodeEnv: process.env.NODE_ENV,
    reactAppEnv: process.env.REACT_APP_ENV,
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'N/A',
    overrides: {
      apiUrl: process.env.REACT_APP_API_URL || 'none',
      serverUrl: process.env.REACT_APP_SERVER_URL || 'none'
    }
  });
}
